export const sanitizeStringWhiteSpace = (str) => str.replace(/\s+/g, ' ').replace(',', ' ');
export const checkWhiteSpace = (str) => str.replace(/\s+/g, '');
